module.exports = __webpack_public_path__ + "img/4f_r_gindako@2x.1d78b705.png";